import { $api } from '@shared/api';
import { handleAxiosFetchErrorsSwal } from '@shared/helpers/fetchHelpers';
import { keysToCamel } from '@shared/helpers/snakeToCamel';
import { IDataResponse, IDataResponseError } from '@shared/model/types/dataResponse.inteface';

import { IFormGenerateEstimate, IFormGenerateEstimateDto } from '../lib/model/types';

type GenerateEstimateResponse = IDataResponse<IFormGenerateEstimate> | IDataResponseError;

export const generateEstimate = async (
    form: IFormGenerateEstimate
): Promise<GenerateEstimateResponse> => {
    // @ts-ignore
    const url = routable.getRoute('generateEstimateWithAi');

    const body: IFormGenerateEstimateDto = {
        construction_type_title: form.constructionTypeTitle,
        description: form.description,
        need_use_directories: form.needUseDirectories,
        supplier_title: form.supplierTitle,
        dimensions: form.dimensions,
    };

    try {
        const response = await $api.post<IDataResponse<IFormGenerateEstimateDto>>(url, body);

        if (response?.data?.status !== 'error' && response?.status === 200) {
            window.location.reload();
        }

        const data = keysToCamel(response?.data?.data);

        return {
            data: data as unknown as IFormGenerateEstimate,
            status: response?.data?.status,
            message: response?.data?.message,
        };
    } catch (error) {
        handleAxiosFetchErrorsSwal(error?.response?.data);
        return error;
    }
};
